module.exports = __webpack_public_path__ + "files/71562b2394cc716536f4b4adec5d22c1.png";